import { render, staticRenderFns } from "./TreatmentProductDropdownModal.vue?vue&type=template&id=4d20e634&scoped=true"
import script from "./TreatmentProductDropdownModal.vue?vue&type=script&lang=js"
export * from "./TreatmentProductDropdownModal.vue?vue&type=script&lang=js"
import style0 from "./TreatmentProductDropdownModal.vue?vue&type=style&index=0&id=4d20e634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d20e634",
  null
  
)

export default component.exports